import { ActionButton, IButtonProps } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';

interface INotificationButtonProps extends IButtonProps {
    isMenuCollapsed: boolean;
}

const StyledButton = styled(ActionButton) <{ isMenuCollapsed: boolean }>`
    padding-left: ${(props) => (props.isMenuCollapsed ? '2px' : '0px')};
    display: flex;
    width: 100%;
    
`;

export const NotificationButton = (props: INotificationButtonProps) => {
    const { isMenuCollapsed, contextMenuProps, hideMenuIcon } = props;

    return (
        <StyledButton isMenuCollapsed={isMenuCollapsed} contextMenuProps={contextMenuProps} hideMenuIcon={hideMenuIcon}>
            {props.children}
        </StyledButton>
    );
};
